export default __webpack_public_path__ + "static/media/breadcrumb.f37c7807.svg";